import commonGlobals from '@opendoor/shared-fe/commonGlobals';
import { getRailsEnv } from '@opendoor/shared-fe/railsEnv';

const odRailsEnv = getRailsEnv();
const secrets = commonGlobals[odRailsEnv] ?? {};

export const COOKIE_KEY = window.location.hostname === 'localhost' ? 'XSRF-TOKEN' : 'XSRF-G-TOKEN';
export const RAILS_ENV = odRailsEnv;
export const WEB_API_URL = secrets.webApiUrl;

export const OD_HOMEPAGE_URL =
  RAILS_ENV === 'production' ? 'https://www.opendoor.com' : 'https://demo.simplersell.com';
